export const SHEDULE_AUDIT_LOGS_RESET_STATE = 'SHEDULE_AUDIT_LOGS_RESET_STATE';
export const SHEDULE_AUDIT_LOGS_CURRENT_ITEM = 'SHEDULE_AUDIT_LOGS_CURRENT_ITEM';

export const SHEDULE_AUDIT_LOGS_REQUEST_LOADING = 'SHEDULE_AUDIT_LOGS_REQUEST_LOADING';
export const SHEDULE_AUDIT_LOGS_REQUEST_SUCCESS = 'SHEDULE_AUDIT_LOGS_REQUEST_SUCCESS';
export const SHEDULE_AUDIT_LOGS_REQUEST_FAILED = 'SHEDULE_AUDIT_LOGS_REQUEST_FAILED';

export const SHEDULE_AUDIT_LOGS_CURRENT_ACTION = 'SHEDULE_AUDIT_LOGS_CURRENT_ACTION';
export const SHEDULE_AUDIT_LOGS_RESET_ACTION = 'SHEDULE_AUDIT_LOGS_RESET_ACTION';